export default class HfHelper {

  static deliveryDays() {
    return [
      { id: 1, name: 'Maandag' },
      { id: 2, name: 'Dinsdag' },
      { id: 3, name: 'Woensdag' },
      { id: 4, name: 'Donderdag' },
      { id: 5, name: 'Vrijdag' },
      { id: 6, name: 'Zaterdag' },
      { id: 7, name: 'Zondag' },
    ];
  }

}